import React, { useState, useEffect, useContext } from "react"
import { AppContext } from "../../AppContext";

import ErrorComp from "../common/ErrorComp";
import DateUtil from "../../common/dateUtil";
import LoadingComp from "../common/LoadingComp";
import AttestationService from "../../services/AttestationService";

import AttestationSearchCriteria from "./AttestationSearchCriteria";
import AttestationGrid from "./AttestationGrid";
import AttestationForm from "./AttestationForm";

const AttestationComp = (props)=>{
    
    const [appContext, setAppContext] = useContext(AppContext);

    const [showError, setShowError] = useState(false);
    const [loading, setLoading] = useState(false);
    
    const [items, setItems] = useState([]);
    const [currentItem, setCurrentItem] = useState({});

    const [dataFrame, setDataFrame] = useState({ startIndex: 0, limit: 10 });
    const [formData, setFormData] = useState({ title: "" });
    const [reqStates, setReqStates] = useState([]);
    const [showDetail, setShowDetail] = useState(false);
    
    let initFromDate = new Date(new Date());
    initFromDate.setDate(initFromDate.getDate() - 90);

    const fromDateStr = DateUtil.toIsoStrDate(initFromDate);

    const initFormData = {
        title: "",
        fromDate: fromDateStr,
        toDate: DateUtil.toIsoStrDate(new Date()),
        reqStatus: "",
    };
    
    const detailClickHandler = (id) => {
        setLoading(true);
        AttestationService.GetDetails(id)
            .then((result) => {
              setLoading(false);
              setCurrentItem(result);
              setShowDetail(true);
            },
            (err) => {
              setLoading(false);
              setShowError(true);
            }
        );
    };

    const handleSaveClick = (item) => {
        AttestationService.SaveForm(item)
            .catch((err) => {
                setShowError(true);
            });
    };

    const handleSubmitClick = (item) => {
        AttestationService.SubmitForm(item)
            .then(() => {
                updateStatus(item);
                setShowDetail(false);
            })
            .catch((err) => {
                setShowError(true);
            });
    };

    const handleClose=(item)=>{
        updateStatus(item);
        setShowDetail(false);
    };

    const handleReopen=(item)=>{
        AttestationService.ReopenForm(item)
            .then(() => {
                updateStatus(item);
            })
            .catch((err) => {
                setShowError(true);
            });
    };

    const handleExport = (id, fileName)=>{
        AttestationService.Export(id, fileName);
    };

    const updateStatus = (item) => {
        items.find(x => x.id == item.id).status = item.status;
        items.find(x => x.id == item.id).statusLabel = item.statusLabel;
        setItems(items);
    }

    const onSearch = (criteria) => {
        searchItems(criteria);
    };

    const searchItems = (criteria) => {
        setLoading(true);
        setItems([]);

        AttestationService.Search(criteria)
            .then(
                (result) => {
                    setItems(result);
                    setLoading(false);
                },
                (err) => {
                    setLoading(false);
                    console.log(err);
                    setShowError(true);
                }
            );
    };

    useEffect(() => {
        searchItems(initFormData);  
    }, []);

    return (
        <div className={appContext.sidebarCollapsed?"content-wrapper sidebar-collapsed":"content-wrapper"}>
            <section className="section-wrapper">
            <div className="page-title no-print">My Attestation Documents</div>
                <div className="section-content">
                    {!showDetail && 
                    <AttestationSearchCriteria onSearch={onSearch} 
                        formData={formData} setFormData={setFormData}
                        reqStates={reqStates} setReqStates={setReqStates} 
                    />}
                    <div className="panel">
                        <div className="panel-header">
                        <div className="panel-header-label">Attestation Documents</div>
                        </div>
                        {!showDetail && (
                            <div className="panel-body">
                                <AttestationGrid items={items} dataFrame={dataFrame} setDataFrame={setDataFrame} onDetail={detailClickHandler}/>    
                            </div>
                        )}
                        {showDetail && <AttestationForm editorItem={currentItem} handleSaveClick={handleSaveClick} handleSubmitClick={handleSubmitClick} itemChanged={updateStatus} handleClose={handleClose} handleReopen={handleReopen} handleExport = {handleExport} />}
                        {showError && <ErrorComp />}
                        {loading && <LoadingComp />}
                    </div>
                </div>
            </section>
        </div>
    );

};

export default AttestationComp;

